import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RedepositoChequeService } from 'src/app/services/redeposito-cheque.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarProtestoComponent } from 'src/app/views/shared/modal-seleccionar-protesto/modal-seleccionar-protesto.component';

@Component({
  selector: 'app-cheques-redeposito-modal-add-edit-redeposito',
  templateUrl: './modal-add-edit-redeposito.component.html',
  styleUrls: ['./modal-add-edit-redeposito.component.scss'],
  providers: [SecurityService],
})
export class ModalAddEditRedepositoComponent implements OnInit {

  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  // Modales
  @ViewChild('agregarredeposito', { static: true }) modalRedeposito: ModalDirective;
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarProtestoComponent, { static: true }) modalSeleccionarProtesto: ModalSeleccionarProtestoComponent

  // Form
  formData: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  private rutUsuario: number
  clienteSeleccionado: any = null
  protestoSeleccionado: any = null
  origenProtestoSeleccionado: number = 1
  isEditing: boolean = true

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private redepositoChequeService: RedepositoChequeService
  ) {
    this.log = this.clog.log('MODAL-REDEPOSITO-CHEQUES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario())

    this.createForm()
    this.formChangesSubscriptions()
  }

  private createForm() {
    this.formData = this.fb.group({
      rutCliente: [null, [Validators.required]],
      nroCheque: [null, [Validators.required]],
      motivo: [null, [Validators.required]]
    });
  }

  private formChangesSubscriptions() {
    this.formData.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        if (this.isEditing)
          this.modalSeleccionarCliente.searchByRut(rutCliente, false)
      })

    this.formData.get("nroCheque").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((nroCheque: string) => {
        if (this.isEditing)
          this.modalSeleccionarProtesto.searchByCodigo(this.clienteSeleccionado.rut, nroCheque)
      })
  }

  show() {
    this.isEditing = true
    this.reset()
    this.modalRedeposito.show()
    this.modalSeleccionarCliente.cleanLast()
    this.modalSeleccionarProtesto.cleanLast()
  }

  loadAndShow(codigo) {
    this.reset()
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        codigo
      }
    }
    this.redepositoChequeService.obtenerRedepositoSegunCodigo(inputParams, ({ mensajes, respuesta: protesto }) => {
      const ok = protesto !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.log('protesto', protesto)
      this.isEditing = false
      this.formData.get('rutCliente').setValue(this.rutService.AgregarDV(protesto.cliente_proveedor_rut))
      this.clienteSeleccionado = {}
      this.clienteSeleccionado.nombre = protesto.cliente_proveedor_nombre
      this.formData.get('nroCheque').setValue(protesto.numero_doc)
      this.protestoSeleccionado = {}
      this.protestoSeleccionado.cliente_proveedor_rut = protesto.cliente_proveedor_rut
      this.protestoSeleccionado.nombre_banco = protesto.nombre_banco
      this.protestoSeleccionado.fecha_registro = protesto.fecha_registro
      this.protestoSeleccionado.fecha = protesto.fecha
      this.formData.get('motivo').setValue(protesto.motivo)
      this.modalRedeposito.show()
    })
  }

  hide() {
    this.modalRedeposito.hide()
  }

  reset() {
    this.formValidatorsService.reset(this.formData)
    this.clienteSeleccionado = null
    this.protestoSeleccionado = null
  }

  openModalSeleccionarClientes() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data
    this.formData.get('rutCliente').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut))
  }

  onNotFoundCliente() {
    this.clienteSeleccionado = null
  }

  openModalSeleccionarProtesto() {
    this.modalSeleccionarProtesto.show(this.clienteSeleccionado.rut)
  }

  onProtestoSeleccionado(cheque) {
    this.log(cheque)
    this.protestoSeleccionado = cheque
    this.formData.get('nroCheque').setValue(this.protestoSeleccionado.numero_doc)
  }

  onNotFoundCheque() {
    this.protestoSeleccionado = null
  }

  guardar() {
    this.formValidatorsService.validateAllFormFields(this.formData)
    if (!this.formData.valid)
      return

    const inputParams = {
      entidad: {
        protesto_cheque_codigo: this.protestoSeleccionado.codigo,
        deposito_documento_codigo: this.protestoSeleccionado.deposito_documento_codigo,
        motivo: this.formData.get('motivo').value,
        monto: this.protestoSeleccionado.monto,
        fecha_registro: this.protestoSeleccionado.fecha_registro,
        cliente_proveedor_rut: this.clienteSeleccionado.rut,
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        rut_usuario: this.rutUsuario,
        pago_codigo: this.protestoSeleccionado.pago_codigo,
        numero_doc: this.protestoSeleccionado.numero_doc
      }
    }

    this.log(JSON.stringify(inputParams))

    this.redepositoChequeService.guardarRedeposito(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.onSuccess.emit()
      this.toastrService.success('Operación realizada con éxito')
      this.hide()
    })
  }

  cerrar() {
    this.hide()
  }

}
